module.exports = __webpack_public_path__ + "static/media/chevron-right-bold.0797be66.svg";